import * as ActionTypes from "./actionTypes";
import * as urls from "../common/urls";
import axios from "axios";


//const secondAction = (data) => ({
//    type: 'SECOND',
//    payload: { ...},
//})

//const firstAction = () => {
//    return (dispatch) => {
//        const response = dispatch({
//            type: 'FIRST',
//            payload: new Promise(...),
//        })

//        response.then((data) => {
//            dispatch(secondAction(data))
//        })
//    }
//}

export function addToCart(selectedProduct, quantity, originalPrice, specialPrice, stockItemId) {
    const product = {
        id: selectedProduct.id, title: selectedProduct.title, groupId: selectedProduct.groupId, groupName: selectedProduct.groupName,
        originalPrice: selectedProduct.originalPrice, specialPrice: selectedProduct.specialPrice, stockItemCode: selectedProduct.stockItemCode, thumbnail: selectedProduct.thumbnail
    };

  //return {
  //  type: ActionTypes.ADD_TO_CART,
  //    payload: new Promise(function (resolve, reject) { resolve({ product, quantity, originalPrice, specialPrice, stockItemId }); })
  //  };

    return (dispatch, getState) => {
        //console.log('state', getState());

        const response = dispatch({
            type: ActionTypes.ADD_TO_CART,
            payload: new Promise(function (resolve, reject) { resolve({ product, quantity, originalPrice, specialPrice, stockItemId }); })
        });

        response.then(() => {
            const { cart, user } = getState();
            if (user.isAuthenticated === true) {
                dispatch(saveCart(cart))
            }
        })
    }
}


export function updateCart(stockItemId, quantity) {
    //return {
    //    type: ActionTypes.UPDATE_CART,
    //    payload: new Promise(function (resolve, reject) { resolve({ productId, quantity }); })
    //};

    return (dispatch, getState) => {
        const response = dispatch({
            type: ActionTypes.UPDATE_CART,
            payload: new Promise(function (resolve, reject) { resolve({ stockItemId, quantity }); })
        });

        response.then(() => {
            const { cart, user } = getState();
            if (user.isAuthenticated === true) {
                dispatch(saveCart(cart))
            }
        })
    }
}

export function removeFromCart(productId) {
    //return {
    //    type: ActionTypes.REMOVE_FROM_CART,
    //    payload: new Promise(function (resolve, reject) { resolve(productId); })
    //};

    return (dispatch, getState) => {
        const response = dispatch({
            type: ActionTypes.REMOVE_FROM_CART,
            payload: new Promise(function (resolve, reject) { resolve(productId); })
        });

        response.then(() => {
            const { cart, user } = getState();
            if (user.isAuthenticated === true) {
                dispatch(saveCart(cart))
            }
        })
    }
}

export function emptyCart() {
    //return {
    //    type: ActionTypes.EMPTY_CART,
    //    payload: new Promise(function (resolve, reject) { resolve(null); })
    //};

    return (dispatch, getState) => {

        const response = dispatch({
            type: ActionTypes.EMPTY_CART,
            payload: new Promise(function (resolve, reject) { resolve(null); })
        });

        response.then(() => {
            const { cart, user } = getState();
            if (user.isAuthenticated === true) {
                dispatch(saveCart(cart))
            }
        })
    }
}

export function setCart(cart) {
    cart.isDefault = true;
    cart.id = 0;
    return { type: ActionTypes.SET_CART, payload: new Promise(function (resolve, reject) { resolve(cart); })};
}

// SAVE CART To Server
export function getCart(userId, cartUrl, isDefault) {
    const url = `${urls.GET_CARTS_URL}?userId=${userId}${'&cartUrl=' + (cartUrl ? cartUrl: '')}${'&isDefault=' + isDefault }`;
    const request = axios.get(url);
    return { type: ActionTypes.GET_CART, payload: request };

}

export function loadCartByUrl(cartUrl) {
    const url = `${urls.GET_CARTS_URL}?${'cartUrl=' + cartUrl}`;
    const request = axios.get(url);
    return { type: ActionTypes.LOAD_CART_BY_URL, payload: request };

}

export function getCarts(userId) {
    const url = `${urls.GET_CARTS_URL}?userId=${userId}${'&cartUrl='}&isDefault=false`;
    const request = axios.get(url);
    return { type: ActionTypes.GET_CARTS, payload: request };

}

export function saveCart(cart, saveAs, newName) {
  
    const cartObj = { ...cart, cartJson: JSON.stringify(cart.lines) }
    if (saveAs) {
        cartObj.isDefault = false;
        cartObj.name = newName;
    }
    const request = axios.post(urls.SAVE_CART_URL, cartObj);

    return { type: ActionTypes.SAVE_CART, payload: request };
}

export function removeCart(userId, cartUrl) {
    const url = `${urls.GET_CARTS_URL}/${cartUrl}`;
    const request = axios.delete(url);
    return { type: ActionTypes.REMOVE_CART, payload: request };
}

// END SAVE CART To Server

export function addToWishlist(product) {
  return { type: ActionTypes.ADD_TO_WISHLIST, payload: product };
}

export function removeFromWishlist(productId) {
  return { type: ActionTypes.REMOVE_FROM_WISHLIST, payload: productId };
}

export function emptyWishlist() {
    return { type: ActionTypes.EMPTY_WISHLIST, payload: null };
}